module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kyoto-0401f7d16e1e72123b122c1ac616b663.png";